import { useEffect, useMemo, useCallback, useRef, useState } from 'react'
import ReportPageGraph from './ReportPageGraph'
import { Skeleton, Paper, Typography, MenuItem, Grid, Container } from '@mui/material'
import { useReportPageContext } from '../context/useReportPageContext'
import { useReportPanelContext } from '../context/useReportPanelContext'
import { ReportGraphProvider } from '../context/useReportGraph'
import { ExitToApp } from '@mui/icons-material'
import ReportPanelPeerAnalysis from './ReportPanelPeerAnalysis'
import ReportIssue from './ReportIssue'
import ReportPanelCompanyInfo from './ReportPanelCompanyInfo'
import MenuBar from '../../../components/ui/menuBar/MenuBar'
import styles from './ReportPage.module.scss'

const ReportPageSection = ({ ticker, selectedTemplate, peerAnalysisTemplate }) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const { data, isLoading, graphParams, exportToCSV, peerAnalysis, issues, companyInfo } = useReportPanelContext()
    const { tab } = useReportPageContext()
    const ref = useRef(null)

    const handleCloseMenu = () => setAnchorEl(null)
    const handleClickExportToCSV = () => {
        exportToCSV()
        handleCloseMenu()
    }

    useEffect(() => {ticker === tab && ref?.current?.scrollIntoView(false);return () => {}},[ticker, tab])

    const getDatasetTemplate = useCallback((field) => {
        return selectedTemplate && selectedTemplate?.find(template => template.dataset_value === field.dataset && template.column_value === field.column)
    },[selectedTemplate])

    const graphs = useMemo(() => (
        selectedTemplate && data?.map((field) => {
            const props = getDatasetTemplate(field)
            const { aggregation_time: aggregationTime, 
                aggregation_type: aggregationType,
                dataset_name: datasetName,
                column_name: columnName,
            } = props
            const { dataset, column, ticker } = field
            const graphType = graphParams[`${dataset}|${column}`]?.graph_type
            return (
                <Grid key={`${ticker}-${dataset}-${column}`} item xs={4}>
                    <ReportGraphProvider data={field}>
                        <ReportPageGraph 
                            data={field} 
                            datasetName={datasetName} 
                            columnName={columnName} 
                            graphType={graphType ?? props?.graph_type}
                            aggregationTime={aggregationTime} 
                            aggregationType={aggregationType}
                        />
                    </ReportGraphProvider>
                </Grid>
            )
    })),[data, getDatasetTemplate, selectedTemplate, graphParams])

    return (
        <Container maxWidth='xl'>
            <Paper elevation={3}>
                <div className={styles['panel-header']}>
                    {!isLoading 
                        ?  <div>
                            <Typography variant="h2">{ticker?.name}</Typography>
                            <ReportIssue issues={issues}/>
                        </div>
                        :<Skeleton height={50} width={200}/>
                    }
                    <div className={styles['menu-bar']}>
                        <MenuBar setAnchorEl={setAnchorEl} anchorEl={anchorEl} color='icon'>
                            <MenuItem onClick={handleClickExportToCSV} classes={{root: styles['menu-item']}}><ExitToApp/> Export to CSV</MenuItem>
                        </MenuBar>
                    </div>
                </div>
                <ReportPanelCompanyInfo data={companyInfo}/>
                {!isLoading 
                    ? <>
                        {/* <ReportPanelPeerAnalysis parentTicker={ticker} peerAnalysis={peerAnalysis} title={{x: peerAnalysisTemplate?.x?.name, y: peerAnalysisTemplate?.y?.name, r: peerAnalysisTemplate?.r?.name}} /> */}
                        <div className={styles['grid-container']}>
                            <Grid container spacing={3}>
                                {graphs}
                            </Grid>
                        </div>
                    </>
                    : <Skeleton classes={{root: styles['section-content-skeleton']}} height={1000}/>
                }
            </Paper>
        </Container>
    )
}

export default ReportPageSection